import React from "react"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbSymbol from "../ui-kit/dfb_symbol"
import DfbParagraph from "../ui-kit/dfb_paragraph"

const CCardFact = ({
  type,
  icon,
  headline,
  subline,
  description,
  anchor,
  href,
  target,
}) => {
  let headlineLevel = ""
  switch (type) {
    case "icon":
      headlineLevel = "h4"
      break
    case "headline":
      headlineLevel = "h3"
      break
    case "number":
    default:
      headlineLevel = "h1"
  }
  return (
    <a href={href} target={target} className="c-CardFact dfb-Card">
      <div className="c-CardFact-content dfb-Card-content">
        {type === "icon" && icon && (
          <div className="c-CardFact-icon">
            <DfbSymbol icon_type={icon} />
          </div>
        )}

        {headline && (
          <DfbHeadline
            headline={headline}
            headline_level="h3"
            noLevelClass="true"
            add_class={`c-CardFact-headline dfb-Headline--${headlineLevel}`}
          />
        )}

        {subline && (
          <DfbHeadline
            headline={subline}
            headline_level="h4"
            noLevelClass="true"
            add_class="c-CardFact-subline dfb-Headline--h5"
          />
        )}

        {description && (
          <DfbParagraph
            text={description}
            add_class="c-CardFact-description"
          />
        )}

        {anchor && (
          <DfbAnchor
            tagName="div"
            text={anchor}
            secondary
            add_class="c-CardFact-anchor"
          />
        )}
      </div>
    </a>
  )
}

export default CCardFact
